import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from '@emotion/core';
import Header from '../../components/Header';
import Subheader from '../../components/Subheader';
import Headline from '../../components/Headline';
import Footer from '../../components/Footer';

const DefaultLayout = ({ headline, children }) => (
  <div
    css={css`
      flex-direction: column;
      display: flex;
      min-height: 100vh;
    `}
  >
    <div
      css={css`
        background-color: #edf0f2;
        flex-direction: column;
        flex: 1 1 auto;
        min-width: 0;
        min-height: 0;
        display: flex;
      `}
    >
      <Header />
      <Subheader backgroundColor="near-black">
        <div
          css={css`
            display: table-cell;
            vertical-align: middle;
            font-size: 24px;
            font-size: 1.5rem;
            color: #fff;
            padding-top: 4px;
            padding-top: 0.25rem;
            padding-bottom: 4px;
            padding-left: 16px;
            padding-left: 1rem;
            padding-right: 16px;
            padding-right: 1rem;
            @media screen and (min-width: 30em) {
              padding-bottom: 0;
              padding-left: 2rem;
              padding-right: 2rem;
              padding-top: 0;
            }
          `}
        >
          <Headline size="h3" uppercase>
            {headline || <span />}
          </Headline>
        </div>
      </Subheader>
      {children}
    </div>
    <Footer />
  </div>
);

DefaultLayout.propTypes = {
  children: PropTypes.node,
  headline: PropTypes.node,
};

DefaultLayout.defaultProps = {
  children: <span />,
  headline: <span />,
};

const mapStateToProps = (state) => ({ headline: state.routes.pageTitle });

export default connect(mapStateToProps)(DefaultLayout);
